import { Controller } from '@hotwired/stimulus'
import { Turbo } from '@hotwired/turbo-rails'

/**
 * Checkable Link Controller
 *
 * This controller enhances checkable elements wrapped in a hyperlink, like radio buttons, checkboxes, etc. with keyboard accessibility.
 * It specifically handles the space key press to tick the element,
 * which is the expected behavior according to WAI-ARIA practices.
 */
export default class extends Controller<HTMLAnchorElement> {
  static values = {
    turboFrameTag: String,
  }

  handleKeydown(event: KeyboardEvent | MouseEvent): void {
    // If it's a keydown event, check if it's the space key
    if (event instanceof KeyboardEvent) {
      if (event.code === 'Space' || event.key === ' ') {
        event.preventDefault() // Prevent page scrolling
        this.changeElementState()
      }
    }
  }

  private changeElementState(): void {
    if (this.element.href) {
      if (this.hasTurboFrameTagValue) {
        Turbo.visit(this.element.href, { frame: this.turboFrameTagValue })
      } else {
        Turbo.visit(this.element.href)
      }
    }
  }

  declare hasTurboFrameTagValue: boolean
  declare turboFrameTagValue: string | undefined
}
